import CloseModalButton from "components/ui_components/closeModalButton";
import React from "react";
import { useTranslation } from "react-i18next";

interface AuthentificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConnect?: () => void;
}

const AuthentificationModal: React.FC<AuthentificationModalProps> = ({
  isOpen = false,
  onClose,
  onConnect,
}) => {
  const { t: translate } = useTranslation("page_detail");
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 xs:px-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 pt-4 px-6 relative border-2 border-yellow-400 flex flex-col">
        <CloseModalButton handleClick={onClose} className="self-end" />
        <div className="flex flex-col items-center">
          <div className="mb-4 flex items-center justify-center w-16 h-16 rounded-full bg-yellow-300 shadow-lg">
            <svg
              className="w-14 h-14 text-blue-600"
              fill="none"
              stroke="currentColor"
              strokeWidth={1}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 11c1.657 0 3-1.343 3-3S13.657 5 12 5s-3 1.343-3 3 1.343 3 3 3zm0 2c-2.67 0-8 1.337-8 4v2h16v-2c0-2.663-5.33-4-8-4z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-2 text-blue-700 text-center">
            {translate("required_connexion")}
          </h2>
          <p className="mb-6 text-center text-[1rem] text-gray-600">
            {translate("auth_required_message")}
          </p>
          <button
            className="w-full bg-blue hover:from-blue-500 hover:to-yellow-400 text-white font-bold py-2 px-4 rounded-lg shadow transition duration-200"
            onClick={onConnect}
          >
            {translate("connexion_button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthentificationModal;
